import { render, staticRenderFns } from "./BlockType23SmallRow.vue?vue&type=template&id=6a7c4b19&scoped=true"
import script from "./BlockType23SmallRow.vue?vue&type=script&lang=ts"
export * from "./BlockType23SmallRow.vue?vue&type=script&lang=ts"
import style0 from "./BlockType23SmallRow.vue?vue&type=style&index=0&id=6a7c4b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c4b19",
  null
  
)

export default component.exports